import { StripeElementLocale } from '@stripe/stripe-js';

import { FsgmLocaleType } from '@common-lib';

export const PortalToStripeLocaleMapper = (
  locale: FsgmLocaleType | undefined,
): StripeElementLocale => {
  if (!locale) {
    return 'auto';
  }

  switch (locale) {
    case 'en-US':
      return 'en';
    case 'sv-SE':
      return 'sv';
    default:
      return locale as StripeElementLocale;
  }
};
